import * as React from 'react';
import DropdownCommentsModal, { BaseDropdownModalProps } from '../DropdownCommentsModal/DropdownCommentsModal';
import { CoughReOpenCommentGroup } from '../../../../misc/api/apiTypes';
import { IsFreeTextAllowed, GetSelectedOptions, DropdownCommentTypes, ValidateSubmittedComments, ShouldDisplay } from '../DropdownCommentsModal/DropdownCommentsHelpers';
import { connect } from 'react-redux';
import { MainState } from '../../../../Core/reducers';
import { useWebPortalLegacyClient } from '../../../../misc/api/WebPortalTokenClient';

interface ReOpenAnalysisSetModalProps extends BaseDropdownModalProps, ReOpenAnalysisSetModalOwnProps {
    
}

interface ReOpenAnalysisSetModalOwnProps {
    onClose: () => void;
    analysisSetId: string;
    isAnalysisSetLinked: boolean;
    selectedDropdownCommentType: DropdownCommentTypes;
}

function ValidateCreateComments(selectedFixedComments: CoughReOpenCommentGroup[], auditAnnotation: string): string[] {

    const errors = [];

    if (IsFreeTextAllowed(selectedFixedComments) && !auditAnnotation.trim()) {
        errors.push("Reopening a cough analysis set with Other or QA - Other selected requires a free text comment.");
    }

    return errors;
}

const ReOpenAnalysisSetModal = ({ analysisSetId, isAnalysisSetLinked, selectedDropdownCommentType, ...props }: ReOpenAnalysisSetModalProps): JSX.Element => {
    const legacyClient = useWebPortalLegacyClient();

    const saveFixedComments = (selectedComments: CoughReOpenCommentGroup[], auditAnnotation: string) => {
        return legacyClient.reOpenAnalysisSet(analysisSetId, auditAnnotation, GetSelectedOptions(selectedComments));
    }

    const validateReopenComments = (selectedComments: CoughReOpenCommentGroup[], auditAnnotation: string): string[] => {
        return ValidateSubmittedComments(selectedComments).concat(ValidateCreateComments(selectedComments, auditAnnotation));
    };

    const shouldDisplay = ShouldDisplay(DropdownCommentTypes.ReOpen);

    return (shouldDisplay(analysisSetId, selectedDropdownCommentType) ? <DropdownCommentsModal loading={false} editMode={false} fetchFixedCommentsForAnalysisSet = {() => Promise.resolve(null)} header = "ReOpen Analysis Set" showLinkedWarning = { isAnalysisSetLinked } saveFixedComments = { saveFixedComments } show = { selectedDropdownCommentType === DropdownCommentTypes.ReOpen} selectedCommentsValidator = { validateReopenComments } {...props } /> : null);
};

function mapStateToProps(state: MainState, ownProps: ReOpenAnalysisSetModalOwnProps): ReOpenAnalysisSetModalProps {
    return {
        analysisSetId: ownProps.analysisSetId,
        isAnalysisSetLinked: ownProps.isAnalysisSetLinked,
        selectedDropdownCommentType: ownProps.selectedDropdownCommentType,
        onClose: ownProps.onClose
    };
}

export default connect<ReOpenAnalysisSetModalProps, void, ReOpenAnalysisSetModalOwnProps>(mapStateToProps)(ReOpenAnalysisSetModal);
